/**
 * Created by rafael on 07.03.17.
 */
import {
  CHANGE_PRINT_STATUS,
  CHANGE_PRINT_FORMAT,
  CHANGE_PRINT_ORIENTATION,
  FINAL_PRINTING_TRIGGERED,
  SET_WINDOW_VIEWPORT,
  SET_PRINT_VIEWPORT,
  CHANGE_PRINT_PDF_STATUS,
} from '../constants';

export const setPrintStatus = () =>
  ({
    type: CHANGE_PRINT_STATUS,
  });

export const changePrintFormat = format =>
  ({
    type: CHANGE_PRINT_FORMAT,
    format,
  });

export const changePrintOrientation = orientation =>
  ({
    type: CHANGE_PRINT_ORIENTATION,
    orientation,
  });

export const printingTriggered = () =>
  ({
    type: FINAL_PRINTING_TRIGGERED,
  });

export const setWindowViewport = viewport =>
  ({
    type: SET_WINDOW_VIEWPORT,
    windowViewport: viewport,
  });

export const setPrintViewport = viewport =>
  ({
    type: SET_PRINT_VIEWPORT,
    printViewport: viewport,
  });

export const changePrintToPdfStatus = (status) =>
  ({
    type: CHANGE_PRINT_PDF_STATUS,
    status: status,
  });
 


// WEBPACK FOOTER //
// src/actions/printSettings.js